export const ecpm: Record<string, string> = {
  // eCPM Tracker
  'ecpm.adunit': 'Theo Ad Unit',
  'ecpm.country': 'Theo quốc gia',
  'ecpm.app': 'Theo App',
  'ecpm.trend': 'Xu hướng',
  'ecpm.impressions': 'Hiển thị',
  'ecpm.requests': 'Yêu cầu',
  'ecpm.fill': 'Tỷ lệ lấp đầy',
  'ecpm.apps': 'Tổng quan App',
  'ecpm.earnings': 'Doanh thu',
  'ecpm.matchRate': 'Tỷ lệ khớp',
  'ecpm.ecpm': 'eCPM',
  'ecpm.totalImpressions': 'Tổng hiển thị',
  'ecpm.adUnitName': 'Ad unit',
  'ecpm.tabSource': 'Nguồn (Mediation)',
  'ecpm.total': 'Tổng cộng',
  'ecpm.tabOverview': 'Tổng quan',
  'ecpm.tabAdFormat': 'Định dạng quảng cáo',
  'ecpm.tabAdUnit': 'Ad Unit',
  'ecpm.tabReports': 'Báo cáo',
  'ecpm.showRate': 'Tỷ lệ hiển thị',
  'ecpm.ctr': 'CTR',
  'ecpm.appsDown': 'App giảm eCPM',
  'ecpm.alertsTitle': 'Cảnh báo eCPM',
  'ecpm.alertsEmpty': 'Không có cảnh báo trong kỳ này.',
  'ecpm.alertsViewAll': 'Xem tất cả',
  'ecpm.vsPrev': 'so kỳ trước',
  'ecpm.granDay': 'Ngày',
  'ecpm.granWeek': 'Tuần',
  'ecpm.granMonth': 'Tháng',
  'ecpm.granHour': 'Giờ',
  'ecpm.appSearch': 'Tìm ứng dụng…',
  'ecpm.status': 'Trạng thái',
  'ecpm.revenue': 'Doanh thu',
  'ecpm.compare': 'So sánh',
  'ecpm.tierDrop': 'Giảm mạnh',
  'ecpm.tierFall': 'Giảm',
  'ecpm.tierVol': 'Biến động',
  'ecpm.stGreat': 'Rất tốt',
  'ecpm.stGood': 'Tốt',
  'ecpm.selectAll': 'Chọn tất cả',
  'ecpm.adUnits': 'Ad unit',
  'ecpm.afTotal': 'Tổng app',
  'ecpm.afUp': 'eCPM tăng',
  'ecpm.afDown': 'eCPM giảm',
  'ecpm.afFlat': 'Đi ngang',
  'ecpm.formats': 'Định dạng',
  'ecpm.srcTotal': 'Tổng nguồn',
  'ecpm.srcUp': 'Nguồn tăng',
  'ecpm.srcDown': 'Nguồn giảm',
  'ecpm.srcRevenue': 'Doanh thu',
  'ecpm.sources': 'Nguồn',
  'ecpm.typeBidding': 'Bidding',
  'ecpm.typeWaterfall': 'Waterfall',
  'ecpm.srcView': 'Xem',
  'ecpm.waterfallTitle': 'Waterfall',
  'ecpm.other': 'Khác',
  'ecpm.barTitle': 'Top 10 nguồn theo eCPM',
  'ecpm.donutTitle': 'Doanh thu theo nguồn',
  'ecpm.exportCsv': 'Xuất CSV',
  'ecpm.instance': 'Instance',
  'ecpm.clicks': 'Clicks',
  'ecpm.repPickApp': 'Chọn app để xem báo cáo',
  'ecpm.repByDim': 'eCPM theo',
  'ecpm.dimCountry': 'Quốc gia',
  'ecpm.dimFormat': 'Định dạng',
  'ecpm.dimAdUnit': 'Ad Unit',
  'ecpm.dimSource': 'Nguồn',
  'ecpm.repCountries': 'Quốc gia',
  'ecpm.allFormats': 'Tất cả định dạng',
  'ecpm.allSources': 'Tất cả nguồn',
  'ecpm.allUnits': 'Tất cả ad unit',
  'ecpm.top': 'Top',
  // eCPM filters
  'ecpmf.range': 'Khoảng thời gian',
  'ecpmf.compare': 'So sánh',
  'ecpmf.app': 'App',
  'ecpmf.country': 'Quốc gia',
  'ecpmf.today': 'Hôm nay',
  'ecpmf.yesterday': 'Hôm qua',
  'ecpmf.last3': '3 ngày qua',
  'ecpmf.last7': '7 ngày qua',
  'ecpmf.last14': '14 ngày qua',
  'ecpmf.last30': '30 ngày qua',
  'ecpmf.thisMonth': 'Tháng này',
  'ecpmf.custom': 'Tùy chọn',
  'ecpmf.samePeriod': 'Cùng kỳ trước',
  'ecpmf.allApps': 'Tất cả app',
  'ecpmf.allCountries': 'Tất cả quốc gia',
  // AdMob Mediation
  'admob.apps': 'Ứng dụng',
  'admob.adUnit': 'Ad Units',
  'admob.waterfall': 'Waterfall',
  'admob.mediationGroup': 'Nhóm Mediation',
  'admob.biddingSource': 'Nguồn Bidding',
  'admob.configuration': 'Cấu hình',
  'admob.bulkImport': 'Nhập hàng loạt',
  'admob.networkIds': 'ID network',
  'admob.addBidding': 'Thêm bidding vào MG',
  'admob.audit': 'Nhật ký',
  'admob.format': 'Định dạng',
  // AdMob Mediation page — account selector + inventory tables
  'admob.account': 'Tài khoản',
  'admob.selectAccount': 'Chọn tài khoản',
  'admob.sync': 'Đồng bộ',
  'admob.syncing': 'Đang đồng bộ…',
  'admob.serviceUnavailable': 'Dịch vụ không khả dụng',
  'admob.noData': 'Không có dữ liệu',
  'admob.noAccounts': 'Chưa cấu hình tài khoản',
  'admob.accountNotRegistered': 'Tài khoản AdMob của bạn chưa được thêm vào công cụ — liên hệ admin',
  // Apps table columns
  'admob.appId': 'App ID',
  'admob.appName': 'Tên ứng dụng',
  'admob.storeId': 'Package / Store ID',
  'admob.platform': 'Nền tảng',
  'admob.pCode': 'pCode',
  // Ad Unit table columns
  'admob.adUnitName': 'Tên Ad Unit',
  'admob.ecpmFloor': 'Sàn eCPM',
  'admob.mgCount': 'Nhóm Mediation',
  // Waterfall table columns
  'admob.waterfallName': 'Tên Waterfall',
  'admob.waterfallId': 'Waterfall ID',
  'admob.primaryAdUnit': 'Ad Unit chính',
  'admob.mgName': 'Nhóm Mediation',
  // MG table columns
  'admob.mgFullName': 'Tên MG',
  'admob.country': 'Quốc gia',
  'admob.bidding': 'Bidding',
  'admob.abTesting': 'A/B Testing',
  // Console Bridge status badge — dot color carries state; short text only when connected
  'admob.consoleBadgeConnected': 'Console đã kết nối',
  'admob.consoleBadgeLoaded': 'Extension đã tải',
  'admob.consoleBadgeNotDetected': 'Chưa cài Extension',
  'admob.consoleOk': 'OK',
  // Ad Unit CRUD actions
  'admob.createAdUnit': 'Tạo Ad Unit',
  'admob.editAdUnit': 'Sửa Ad Unit',
  'admob.deleteAdUnit': 'Xóa Ad Unit',
  'admob.createAdUnitSuccess': 'Đã tạo ad unit',
  'admob.deleteAdUnitSuccess': 'Đã xóa ad unit',
  'admob.renameSuccess': 'Đã đổi tên ad unit',
  'admob.deleteRevenueWarning': 'Cảnh báo: AdMob chặn xóa nếu ad unit có doanh thu trong 30 ngày qua.',
  'admob.deleteNeedsExtension': 'Cần extension AdMob Console Bridge để xóa ad unit',
  // Waterfall create (paired wf unit + manual floor)
  'admob.wfCreate.button': 'Tạo Waterfall',
  'admob.wfCreate.title': 'Tạo Waterfall Ad Unit',
  'admob.wfCreate.country': 'Quốc gia (tùy chọn)',
  'admob.wfCreate.customName': 'Tên tùy chỉnh (tùy chọn)',
  'admob.wfCreate.overridePh': 'Tên riêng (tùy chọn)',
  'admob.wfCreate.pickHint': 'Chọn ad unit chính',
  'admob.wfCreate.selected': 'đã chọn',
  'admob.wfCreate.searchPh': 'Tìm ad unit…',
  'admob.wfCreate.formatRequired': 'Cần chọn format',
  'admob.wfCreate.floorRequired': 'Cần nhập eCPM floor',
  'admob.wfCreate.primaryRequired': 'Chọn ít nhất một ad unit chính',
  'admob.wfCreate.createN': 'Tạo {n} waterfall',
  'admob.wfCreate.ok': 'đã tạo',
  // Waterfall cleanup (unused wf units)
  'admob.wfCleanup.button': 'Dọn wf không dùng',
  'admob.wfCleanup.title': 'Dọn dẹp waterfall unit không dùng',
  'admob.wfCleanup.scanning': 'Đang quét wf unit không dùng…',
  'admob.wfCleanup.total': 'Tổng',
  'admob.wfCleanup.inUse': 'Đang dùng',
  'admob.wfCleanup.unused': 'Không dùng',
  'admob.wfCleanup.noUnused': 'Không có wf unit nào không dùng.',
  'admob.wfCleanup.deleteN': 'Xóa {n} wf',
  // Form fields
  'admob.displayName': 'Tên hiển thị',
  'admob.displayNameRequired': 'Tên hiển thị là bắt buộc',
  'admob.adFormat': 'Định dạng quảng cáo',
  'admob.selectApp': 'Chọn ứng dụng',
  // Floor edit (shared by ad unit modal + waterfall inline)
  'admob.editFloor': 'Sàn eCPM',
  'admob.floorModeGoogle': 'Google tối ưu',
  'admob.floorModeManual': 'Thủ công',
  'admob.floorModeDisabled': 'Tắt',
  'admob.floorStrategyHigh': 'Sàn cao',
  'admob.floorStrategyMedium': 'Sàn trung bình',
  'admob.floorStrategyLow': 'Mọi giá',
  'admob.manualFloorRequired': 'Sàn thủ công USD phải > 0',
  'admob.floorStrategy': 'Chiến lược',
  'admob.applyFloor': 'Áp dụng sàn qua Console',
  'admob.floorApplied': 'Đã áp dụng sàn qua AdMob Console',
  'admob.connectConsole': 'Kết nối console để dùng',
  'admob.extensionReadyStatus': 'Extension sẵn sàng',
  // Misc
  'admob.creating': 'Đang tạo…',
  'admob.rename': 'Đổi tên',
  // MG table columns (added)
  // Configuration tab — account management
  'admob.connectedAccounts': 'Tài khoản kết nối',
  'admob.publisherId': 'Publisher ID',
  'admob.googleEmail': 'Email Google',
  'admob.refreshToken': 'Refresh Token',
  'admob.lastSynced': 'Đồng bộ lần cuối',
  'admob.statusLabel': 'Trạng thái',
  'admob.actions': 'Thao tác',
  'admob.disable': 'Vô hiệu',
  'admob.confirmDisable': 'Vô hiệu hóa tài khoản',
  'admob.addAccount': 'Thêm tài khoản',
  'admob.addAccountHint': 'Kết nối tài khoản AdMob mới qua OAuth refresh token.',
  'admob.oauthConnect': 'Kết nối / cấp lại quyền Google',
  'admob.oauthConnectHint': 'Bấm nút để đăng nhập Google sở hữu tài khoản AdMob (cấp cả quyền ghi). Sau khi đồng ý, trang callback hiện một mã — copy mã đó dán vào ô bên dưới. Tài khoản trùng publisher sẽ được cập nhật token, không tạo trùng.',
  'admob.oauthStart': 'Đăng nhập Google',
  'admob.oauthCode': 'Mã uỷ quyền (authorization code)',
  'admob.oauthFinish': 'Hoàn tất kết nối',
  'admob.oauthDone': 'Đã kết nối tài khoản.',
  'admob.accountAdded': 'Đã thêm tài khoản thành công.',
  // Bidding Source tab
  'admob.ok': 'OK',
  // Bulk Import tab
  'admob.bi.abMode': 'Chế độ A/B',
  'admob.bi.abNone': 'Không',
  'admob.bi.abNew': 'A/B mới',
  'admob.bi.abExist': 'A/B sẵn có',
  'admob.bi.abPct': 'Phân bổ % (B)',
  'admob.bi.run': 'Chạy',
  'admob.bi.running': 'Đang chạy…',
  'admob.syncPartialFail': 'Sync xong nhưng một số resource lỗi:',
  'admob.bi.sheetLink': 'Google Sheet link',
  'admob.bi.sheetHint': 'Dán link Google Sheet trước',
  'admob.bi.fetchPreview': 'Fetch & Preview',
  'admob.bi.fetching': 'Đang tải sheet…',
  'admob.bi.fetchFailed': 'Tải sheet thất bại',
  'admob.bi.fetchedFrom': 'Đã tải từ tab',
  'admob.bi.sheetEmpty': 'Tab "{sheet}" không có dữ liệu',
  'admob.bi.confirmRun': 'Tạo {n} mediation group trong AdMob? Thao tác này tạo tài nguyên THẬT và không thể hoàn tác.',
  'admob.bi.runComplete': 'Hoàn tất: {done} thành công, {failed} thất bại',
  'admob.bi.columnGuide': 'Cột dữ liệu cần có',
  'admob.bi.namesHint': 'standartNames: một hoặc nhiều tên ad unit, cách nhau bằng dấu phẩy. Tên chưa có sẽ được tạo khi Run (tên đầu tiên là ad unit chính của waterfall). Native có "small" trong tên được tạo không bật Video.',
  'admob.bi.biddingPartners': 'Bidding Partners',
  'admob.bi.biddingPartnersHint': '(tick network muốn thêm — network vẫn cần mapping enabled trên ad unit chính; network tự bỏ qua với format nó không hỗ trợ)',
  'admob.bi.onlyFormats': 'chỉ',
  'admob.bi.rowErrors': 'Lỗi dòng dữ liệu',
  'admob.bi.tiers': 'Tầng',
  'admob.bi.countriesIso': 'Quốc gia (ISO)',
  'admob.bi.selectAll': 'Chọn mọi group chạy được',
  'admob.bi.selectRow': 'Đưa group này vào lượt chạy',
  'admob.bi.notRunnable': 'Chế độ này không chạy được group đó — không có gì để đưa vào',
  // Audit tab
  'admob.filterAccountId': 'ID tài khoản',
  'admob.auditAllAccounts': 'Tất cả tài khoản',
  'admob.auditLimit': 'Giới hạn',
  'admob.applyFilter': 'Áp dụng',
  'admob.noAuditEntries': 'Không có mục audit nào.',
  'admob.auditWhen': 'Thời gian',
  'admob.auditActor': 'Người thực hiện',
  'admob.auditAction': 'Hành động',
  'admob.auditTarget': 'Đối tượng',
  'admob.auditDetails': 'Chi tiết',
  'admob.auditError': 'Lỗi',
  'admob.showDiff': 'Xem thay đổi',
  // MG status + edit actions
  'admob.mg.pauseMg': 'Tạm dừng MG',
  'admob.mg.enableMg': 'Kích hoạt MG',
  'admob.mg.removeMg': 'Xóa MG',
  'admob.mg.editLines': 'Sửa Lines',
  'admob.mg.createMg': 'Tạo MG',
  'admob.mg.confirmPause': 'Tạm dừng nhóm mediation này?',
  'admob.mg.confirmRemove': 'Xóa nhóm mediation này? Không thể hoàn tác.',
  'admob.mg.consoleRequired': 'Cần kết nối Console bridge',
  'admob.mg.pauseOk': 'Đã tạm dừng MG',
  'admob.mg.enableOk': 'Đã kích hoạt MG',
  'admob.mg.removeOk': 'Đã xóa MG',
  'admob.mg.statusError': 'Lỗi thay đổi trạng thái MG',
  'admob.mg.selectAll': 'Chọn tất cả',
  'admob.mg.removeSelected': 'Xóa mục đã chọn',
  'admob.mg.bulkRemoveTitle': 'Xóa Mediation Group',
  'admob.mg.bulkRemoveConfirm': 'Xóa {n} mediation group? Hành động này không thể hoàn tác.',
  'admob.mg.bulkRemoveOk': 'đã xóa',
  'admob.mg.bulkRemoveFailed': 'lỗi',
  'admob.mg.savingLines': 'Đang lưu lines…',
  'admob.mg.saveLines': 'Lưu Lines',
  'admob.mg.linesError': 'Lỗi lưu lines',
  'admob.mg.state': 'Trạng thái',
  'admob.mg.adSource': 'Ad Source',
  'admob.mg.enabled': 'Bật',
  'admob.mg.disabled': 'Tắt',
  'admob.mg.createTitle': 'Tạo Nhóm Mediation',
  'admob.mg.noLines': 'Không có lines nào',
  'admob.mg.noAdUnits': 'Không có ad unit',
  'admob.mg.regions': 'Mã quốc gia (tùy chọn, VD: US,VN)',
  // Create MG modal — erp single-mode flow parity
  'admob.app': 'App',
  'admob.mg.adUnitsPick': 'Ad unit (theo app + format)',
  'admob.mg.noAuMatch': 'Không có ad unit phù hợp',
  'admob.mg.dupName': 'Đã tồn tại mediation group trùng tên',
  'admob.mg.progressCreating': 'Đang tạo Mediation Group (resolve mappings)… có thể mất 10–30s',
  'admob.mg.progressAb': 'Đã tạo MG. Đang bật A/B test…',
  'admob.mg.progressSync': 'Đang sync inventory…',
  'admob.mg.noBiddingSources': 'Không có bidding source cho app + format này',
  'admob.mg.noWaterfallUnits': 'Không có waterfall ad unit cho app + format này',
  'admob.mg.wfSearchPh': 'Tìm theo tên waterfall…',
  'admob.mg.noLinesYet': 'Chọn app + format để nạp tùy chọn',
  'admob.mg.wfNoFloor': 'thiếu eCPM floor',
  'admob.mg.abEnable': 'A/B test (Bản B = chỉ bidding)',
  'admob.mg.abName': 'Tên A/B test',
  'admob.mg.abPct': 'Lưu lượng bản B',
  'admob.mg.abStarted': 'Đã bật A/B test',
  'admob.mg.abFailed': 'A/B thất bại',
  'admob.mg.createdOk': 'Đã tạo Mediation Group',
  'admob.mg.linesDropped': 'Line bị bỏ qua',
  'admob.mg.modeSingle': 'Tạo 1 Mediation Group',
  'admob.mg.defDuplicateName': 'bỏ qua: trùng tên với MG mặc định đã chọn',
  'admob.mg.defOtherOfFormat': 'đã có MG REWARDED: {name}',
  'admob.mg.modeDefault': 'Tạo MG mặc định',
  'admob.mg.defExisting': 'đã có',
  'admob.mg.defExistingOther': 'Đã tồn tại (khác)',
  'admob.mg.defAddCustom': 'Thêm MG tùy chỉnh',
  'admob.mg.defRun': 'Tạo các MG đã chọn',
  'admob.mg.defCreds': 'Credentials',
  'admob.mg.storeOnlyHint': 'Kho còn ID {names} nhưng mạng này chỉ lưu kho: không tự vào MG mới. Thêm tay bằng "Add bidding" ở trên, hoặc sau khi tạo MG thì dùng tab "Thêm bidding vào MG".',
  'admob.mg.defExtraHint': 'AppLovin, Liftoff, IS chỉ lưu kho: ID đã lưu không tự lên MG mới, trừ khi MG của app đã dùng mạng đó. Thêm vào MG bằng tab "Thêm bidding vào MG".',
  'admob.mg.defExpandAll': 'Mở tất cả',
  'admob.mg.defCollapseAll': 'Thu gọn tất cả',
  'admob.mg.defApplyTo': 'Áp cho',
  'admob.mg.defSavingBidding': 'Đang lưu bidding',
  'admob.mg.addBidding': 'Thêm bidding',
  'admob.mg.mirrorHint': 'Tự thêm cả {names} với cùng App ID và Placement ID. Hướng dẫn của Pangle nói bản US/KR thường cần ID riêng; nếu dòng đi kèm không có request sau ~7 ngày thì cần ID riêng. Nguồn KR phải được bật quan hệ đối tác trên từng tài khoản AdMob, chưa bật thì dòng đó bị bỏ và ghi trong log.',
  'admob.mg.mirrorKeptOwn': 'Giữ ID riêng đã lưu, không ghi đè bằng ID của Pangle ROW',
  'admob.mg.noBiddingCandidates': 'Không còn network khả dụng cho format này',
  'admob.mg.countrySearchPh': 'Gõ tên nước hoặc mã…',
  // Create Ad Unit — floor options + partner bidding (erp parity)
  'admob.au.floorDisabled': 'Tắt',
  'admob.au.floorGoogle': 'Google tối ưu',
  'admob.au.floorManual': 'Thủ công (cặp waterfall)',
  'admob.au.floorStrategy': 'Chiến lược',
  'admob.au.floorApplying': 'Đang áp floor Google tối ưu…',
  'admob.au.floorFailed': 'Áp floor thất bại',
  'admob.au.floorNeedsExtension': 'Floor Google tối ưu cần extension AdMob Console Bridge',
  'admob.au.wfPairCreating': 'Đang tạo waterfall unit cặp…',
  'admob.au.wfPairFailed': 'Tạo cặp waterfall thất bại',
  'admob.au.biddingMapping': 'Đang tạo bidding mapping',
  'admob.au.biddingFailed': 'Bidding mapping thất bại',
  'admob.au.withBidding': 'Tạo partner bidding mappings',
  'admob.bi.skipHint': 'skip = MG trùng tên đã tồn tại — chuyển chế độ A/B sang "exist" để chạy trên MG đó',
  // Edit MG modal — erp flow parity
  'admob.mg.editTitle': 'Sửa Mediation Group',
  'admob.mg.mgId': 'Mediation Group ID',
  'admob.mg.status': 'Trạng thái',
  'admob.mg.abViewOnly': 'Nhóm này đang chạy A/B experiment — chỉ xem, không sửa được.',
  'admob.mg.abEnableEdit': 'Bật A/B Test',
  'admob.mg.abAlloc': 'Phân bổ người dùng',
  'admob.mg.abHint': 'Bản A = lines hiện tại của MG (đối chứng). Bản B = các line bidding + các tier waterfall dựng bên dưới (cần ≥1 line).',
  'admob.mg.abVariantA': 'Bản A (đối chứng — waterfall hiện tại)',
  'admob.mg.abVariantB': 'Bản B = A + các tier waterfall thêm bên dưới',
  'admob.mg.abPickWf': 'Chọn wf unit có sẵn…',
  'admob.mg.abAdd': 'Thêm',
  'admob.mg.abAddNew': 'Thêm wf mới',
  'admob.mg.abCopyA': 'Chép A → B',
  'admob.mg.abNoWfCopy': 'Bản A không có tier waterfall để chép',
  'admob.mg.abNameRequired': 'Cần nhập tên A/B test',
  'admob.mg.abNeedLine': 'Bản B cần ít nhất một line',
  'admob.mg.abStartedPartial': 'Đã bật A/B nhưng một số tier bị bỏ qua (không map được)',
  'admob.mg.progressAbCreate': 'Đang tạo A/B experiment…',
  'admob.mg.progressPatch': 'Đang cập nhật…',
  'admob.mg.updateAus': 'Cập nhật Ad Units',
  'admob.mg.updateBidding': 'Cập nhật Bidding',
  'admob.mg.updateWaterfall': 'Cập nhật Waterfall',
  'admob.mg.addTier': 'Thêm tier',
  'admob.mg.newTierInvalid': 'Tier waterfall cần tên + eCPM > 0',
  'admob.mg.auChangeNoLineEdit': 'Không hỗ trợ vừa đổi ad units vừa sửa lines — làm riêng từng bước.',
  'admob.mg.atLeastOneAu': 'Cần ít nhất một ad unit',
  'admob.mg.nothingToUpdate': 'Không có gì để cập nhật — đổi một trường hoặc tick một mục.',
  'admob.mg.auUpdated': 'Đã cập nhật ad units',
  'admob.mg.saved': 'Đã lưu',
  'admob.mg.stopAb': 'Dừng A/B',
  'admob.mg.stopAbTitle': 'Dừng A/B Test',
  'admob.mg.stopAbChoose': 'Chọn bản giữ lại làm bản thắng:',
  'admob.mg.keepA': 'Giữ bản A (đối chứng)',
  'admob.mg.keepB': 'Giữ bản B',
  'admob.mg.stoppingAb': 'Đang dừng A/B test…',
  'admob.mg.abStopped': 'Đã dừng A/B. Đang làm mới…',
  'admob.mg.stopAbError': 'Lỗi dừng A/B',
  'admob.mg.createError': 'Lỗi tạo nhóm mediation',
  'admob.mg.creating': 'Đang tạo…',
  // Inventory filter bar (client-side, erp-parity)
  'admob.filter.allFormats': 'Tất cả định dạng',
  'admob.filter.allCountries': 'Tất cả quốc gia',
  'admob.filter.allPrimary': 'Tất cả ad unit chính',
  'admob.filter.wfNamePh': 'Lọc theo tên…',
  'admob.filter.selectApp': 'Chọn app',
  'admob.filter.selectAppPrompt': 'Chọn app để xem danh sách',
  // Create App pipeline modal (admob.ca.*)
  'admob.createApp': 'Tạo App',
  'admob.ca.title': 'Tạo ứng dụng',
  'admob.ca.storeId': 'Store / Package ID',
  'admob.ca.createAdUnits': 'Tạo ad unit mặc định',
  'admob.ca.template': 'Mẫu ad unit',
  'admob.ca.formats': 'Định dạng & ad unit',
  'admob.ca.createMgs': 'Tạo mediation group theo định dạng',
  'admob.ca.confirmWarning': 'Thao tác này tạo tài nguyên THẬT trên AdMob và không thể hoàn tác. Sẽ tạo:',
  'admob.ca.adUnits': 'ad unit(s)',
  'admob.ca.mgs': 'nhóm mediation',
  'admob.ca.next': 'Tiếp theo',
  'admob.ca.runPipeline': 'Chạy Pipeline',
  'admob.ca.running': 'Đang chạy pipeline…',
  'monetAssign.tab': 'Phân công App',
  'monetAssign.assigned': 'MO phụ trách',
  'monetAssign.addMo': 'Thêm MO',
  'monetAssign.showInactive': 'Hiện app Inactive',
  'monetAssign.history': 'Lịch sử',
  'monetAssign.primary': 'Chính',
  'monetAssign.secondary': 'Phụ',
  'monetAssign.makePrimary': 'Đặt làm MO chính',
  'monetAssign.logTime': 'Thời gian',
  'monetAssign.logChange': 'Thay đổi',
  'monetAssign.logBy': 'Người sửa',
  'monetAssign.roleHint': 'MO đầu tiên = chính (phụ trách app); còn lại là phụ — vẫn xem được app trong báo cáo.',
  // Admin > Quyền phân công MO — ai được sửa phân công app (ngoài admin).
  'monetEditors.tab': 'Quyền phân công MO',
  'monetEditors.title': 'Ai được sửa phân công app',
  'monetEditors.help': 'Admin luôn sửa được. Những người tick ở đây cũng sửa được trang Phân công App, ngoài ra không thêm quyền gì khác.',
  'monetEditors.saved': 'Đã lưu. Người vừa được cấp thấy ngay, không phải chờ.',
  'monetEditors.emptyWarning': 'Danh sách rỗng — chỉ còn admin sửa được phân công app.',
  'monetEditors.notActiveMonet': 'không còn là MONET đang hoạt động',
  'monetEditors.noStaff': 'Không có nhân sự MONET nào đang hoạt động.',
};
